module.exports = __webpack_public_path__ + "static/media/17.9bc15bff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/17.svg
// module id = 389
// module chunks = 14